var map = {
	"./Back-b.png": "lYAt",
	"./Back-b@2x.png": "/C58",
	"./Back-xt.png": "b6J6",
	"./Back-xt@2x.png": "UJAT",
	"./Back-z.png": "ooQs",
	"./Back-z@2x.png": "N89V",
	"./Begin-xt.png": "RhWI",
	"./Begin-z.png": "h7vF",
	"./Continue-b.png": "K6sA",
	"./Continue-b@2x.png": "Lv7Y",
	"./Continue-xt.png": "eH5N",
	"./Continue-xt@2x.png": "qlTV",
	"./Continue-z.png": "FynY",
	"./Continue-z@2x.png": "gvz7",
	"./Demo-b.png": "utvP",
	"./Demo-b@2x.png": "tImH",
	"./Demo-x-en.png": "r1Q8",
	"./Demo-x.png": "pqTO",
	"./Demo-x@2x.png": "OmeM",
	"./Demo-z-en.png": "FXaV",
	"./Demo-z.png": "lDma",
	"./Demo-z@2x.png": "6Wrv",
	"./Dict 标注.png": "fBiL",
	"./Dict 标注@2x.png": "W+Cp",
	"./Dict-b.png": "/TgP",
	"./Dict-b@2x.png": "IJcD",
	"./Dict-x-en.png": "nbmt",
	"./Dict-x.png": "B4Qi",
	"./Dict-x@2x.png": "jkJ5",
	"./Dict-z-en.png": "Mdvy",
	"./Dict-z.png": "vril",
	"./Dict-z@2x.png": "EDPS",
	"./Explan-b.png": "oDl1",
	"./Explan-b@2x.png": "oPEh",
	"./Explan-x.png": "Nl+Q",
	"./Explan-z.png": "Z/cC",
	"./Explan-z@2x.png": "F/yO",
	"./Explani-x@2x.png": "6OWZ",
	"./Flag 标注.png": "dRDA",
	"./Flag 标注@2x.png": "SahX",
	"./Flag-b.png": "zlh2",
	"./Flag-b@2x.png": "2h1n",
	"./Flag-x-en.png": "UeWd",
	"./Flag-x.png": "xVkZ",
	"./Flag-x@2x.png": "QJhP",
	"./Flag-z-en.png": "lc5t",
	"./Flag-z.png": "SdEP",
	"./Flag-z@2x.png": "QW/q",
	"./Help-b.png": "cSNH",
	"./Help-b@2x.png": "TxP6",
	"./Help-xt.png": "BiVp",
	"./Help-xt@2x.png": "3b4z",
	"./Help-z.png": "VGNC",
	"./Help-z@2x.png": "eqTh",
	"./Locate 标注.png": "+jj8",
	"./Locate 标注@2x.png": "pJJ7",
	"./Locate-b.png": "AlOu",
	"./Locate-b@2x.png": "xR8n",
	"./Locate-x-en.png": "j+sz",
	"./Locate-x.png": "SFb2",
	"./Locate-z-en.png": "MGeg",
	"./Locate-z.png": "/52d",
	"./Locate-z@2x.png": "W+8k",
	"./Next-b.png": "C08M",
	"./Next-b@2x.png": "P9XQ",
	"./Next-xt.png": "hOoM",
	"./Next-xt@2x.png": "FKqu",
	"./Next-z.png": "WRuP",
	"./Next-z@2x.png": "OqqI",
	"./Note 标注.png": "f7v1",
	"./Note 标注@2x.png": "yrCX",
	"./Note-b.png": "dAYM",
	"./Note-b@2x.png": "Gdtb",
	"./Note-x-en.png": "x5gs",
	"./Note-x.png": "paOn",
	"./Note-x@2x.png": "Ip2L",
	"./Note-z-en.png": "Pdnl",
	"./Note-z.png": "+tso",
	"./Note-z@2x.png": "XGBV",
	"./Ok-b.png": "G4zC",
	"./Ok-b@2x.png": "Oaqo",
	"./Ok-xt.png": "c9Mj",
	"./Ok-xt@2x.png": "iPMQ",
	"./Ok-z.png": "+fs0",
	"./Ok-z@2x.png": "FTBq",
	"./PREPARATION TIME.png": "4DBV",
	"./PREPARATION TIME@2x.png": "2iSN",
	"./RePlay-b.png": "eGEA",
	"./RePlay-b@2x.png": "mMv8",
	"./RePlay-x-en.png": "YI9o",
	"./RePlay-x.png": "qqwv",
	"./RePlay-x@2x.png": "GW1V",
	"./RePlay-z-en.png": "P+Me",
	"./RePlay-z.png": "RdKu",
	"./RePlay-z@2x.png": "2jMj",
	"./Report 标注.png": "Zbsd",
	"./Report 标注@2x.png": "KjT/",
	"./Report-b.png": "FTbk",
	"./Report-b@2x.png": "2bu3",
	"./Report-x-en.png": "PXMU",
	"./Report-x.png": "d2n9",
	"./Report-x@2x.png": "I4+c",
	"./Report-z-en.png": "HlkW",
	"./Report-z.png": "GHWx",
	"./Report-z@2x.png": "YcsV",
	"./Retum-b.png": "0YqK",
	"./Retum-b@2x.png": "0Rnq",
	"./Retum-xt.png": "vqma",
	"./Retum-xt@2x.png": "6yPk",
	"./Retum-z.png": "mT+G",
	"./Retum-z@2x.png": "Ioyr",
	"./Review-b.png": "0cR0",
	"./Review-b@2x.png": "p62U",
	"./Review-xt.png": "h4uJ",
	"./Review-xt@2x.png": "V8BP",
	"./Review-z.png": "mQwa",
	"./Review-z@2x.png": "i8+0",
	"./Script-b.png": "u22M",
	"./Script-b@2x.png": "cYvI",
	"./Script-x.png": "TNfM",
	"./Script-x@2x.png": "JKGv",
	"./Script-z.png": "Z2a4",
	"./Script-z@2x.png": "7s7T",
	"./TRANS 标注.png": "peKU",
	"./TRANS 标注@2x.png": "Kw7K",
	"./Trans-b.png": "e/NA",
	"./Trans-b@2x.png": "eHZR",
	"./Trans-x-en.png": "5m8r",
	"./Trans-x.png": "svmj",
	"./Trans-x@2x.png": "nA73",
	"./Trans-z-en.png": "irTf",
	"./Trans-z.png": "xTTm",
	"./Trans-z@2x.png": "/rVB",
	"./View Question-1.png": "Sc/d",
	"./View Question-1@2x.png": "Aje9",
	"./View Question-2.png": "Ubtb",
	"./View Question-2@2x.png": "YOur",
	"./View Text-1.png": "4o+r",
	"./View Text-1@2x.png": "ijBQ",
	"./View Text-2.png": "Z2z/",
	"./View Text-2@2x.png": "r8q3",
	"./Volume-b.png": "ZtS1",
	"./Volume-b@2x.png": "LYEi",
	"./Volume-xt.png": "vXHk",
	"./Volume-xt@2x.png": "Y7ya",
	"./Volume-z.png": "aDyY",
	"./Volume-z@2x.png": "Fc9u",
	"./adjust-microphone.png": "+jW+",
	"./ar-line-head.png": "zOIm",
	"./backWard_disable_2x.png": "ii6X",
	"./backWard_hover_2x.png": "PIdk",
	"./backWard_normal_2x.png": "1UU0",
	"./banner-exam.png": "mU10",
	"./banner-score.png": "yM72",
	"./banner-unvip.png": "DOD1",
	"./banner-vip.png": "tec/",
	"./charge-title-img.png": "zv/p",
	"./check-f-icon.png": "3v0V",
	"./check-t-icon.png": "oCAi",
	"./customerService.png": "feZX",
	"./drag-icon-s.png": "TwQW",
	"./drag-icon.png": "8E5g",
	"./explan-x-en.png": "xRdL",
	"./explan-z-en.png": "es5i",
	"./fankui-b.png": "bVco",
	"./fankui-b@2x.png": "enYn",
	"./fankui-x.png": "nGju",
	"./fankui-x@2x.png": "/puk",
	"./fankui-z.png": "DH/X",
	"./fankui-z@2x.png": "tNd7",
	"./forWard_disable_2x.png": "dQ6p",
	"./forWard_hover_2x.png": "GKEq",
	"./forWard_normal_2x.png": "03aO",
	"./free.png": "Pyjv",
	"./frequency-active@2x.png": "wYj8",
	"./frequency-icon@2x.png": "Q4ou",
	"./goToQues_disable_2x.png": "PLNl",
	"./goToQues_hover_2x.png": "y1PF",
	"./goToQues_noraml_2x.png": "LwZf",
	"./headset-icon.png": "Y7ib",
	"./headset.png": "6u3a",
	"./ico-exercise1-active.png": "4vCD",
	"./ico-exercise1.png": "4KlN",
	"./ico-exercise2-active.png": "/UwV",
	"./ico-exercise2.png": "oj2G",
	"./ico-exercise3-active.png": "cLBy",
	"./ico-exercise3.png": "Htu6",
	"./ico-exercise4-active.png": "Qlqx",
	"./ico-exercise4.png": "xniJ",
	"./ico-exerciseOut4-active.png": "uqVN",
	"./ico-exerciseOut4.png": "3ZZj",
	"./icon-WeChat.png": "M8V2",
	"./icon-book-active.png": "zdt8",
	"./icon-book.png": "zwDf",
	"./icon-browse-active.png": "04qN",
	"./icon-browse.png": "NJrD",
	"./icon-browse2.png": "d9JK",
	"./icon-close.png": "T7cN",
	"./icon-collection.png": "Us2W",
	"./icon-continue-active.png": "jkVD",
	"./icon-continue-disble.png": "6/rl",
	"./icon-continue.png": "td8H",
	"./icon-delete.png": "h4kX",
	"./icon-dict-active.png": "LgST",
	"./icon-dict.png": "MuiG",
	"./icon-down-active.png": "LqjB",
	"./icon-down.png": "Y2Bv",
	"./icon-edit.png": "rj+V",
	"./icon-edit2.png": "XwEi",
	"./icon-enterExam-active.png": "srMJ",
	"./icon-enterExam.png": "IaDN",
	"./icon-favorite-active.png": "YIj2",
	"./icon-favorite.png": "0xqq",
	"./icon-flag-article.png": "tGhL",
	"./icon-flag-subject.png": "uihF",
	"./icon-history.png": "e4Tg",
	"./icon-note-active.png": "QcII",
	"./icon-note.png": "Pqd9",
	"./icon-ok.png": "Eu7u",
	"./icon-profile.png": "fBXl",
	"./icon-qq.png": "MMkx",
	"./icon-report-active.png": "gkQi",
	"./icon-report.png": "RtkX",
	"./icon-settings.png": "ZPVV",
	"./icon-statistical-report.png": "cpmb",
	"./icon-success.png": "6wUG",
	"./icon-test.png": "KDOG",
	"./icon-testReport-active@2x.png": "XWgN",
	"./icon-testReport.png": "2vqX",
	"./icon-trans-active.png": "J3n6",
	"./icon-trans.png": "iR6k",
	"./icon-vip.png": "zzgM",
	"./icon-warning.png": "K8yI",
	"./icon_cha@2x.png": "ilSv",
	"./icon_check@2x.png": "miaV",
	"./icon_jia@2x.png": "gn/C",
	"./icon_juzi@2x.png": "YYqm",
	"./icon_juzi_pre@2x.png": "4FOD",
	"./icon_shang@2x.png": "eusE",
	"./icon_shengci@2x.png": "BHxH",
	"./icon_shengci_pre@2x.png": "jov5",
	"./icon_sousuo@2x.png": "nRNu",
	"./icon_xia@2x.png": "BE1f",
	"./icon_zhiding@2x.png": "l8ff",
	"./icon_zhiding_lv@2x.png": "FmZe",
	"./icon_zidian@2x.png": "JAhz",
	"./icon_zidian_pre@2x.png": "yGfi",
	"./logo.png": "XHjd",
	"./logo2.png": "/e2M",
	"./luyin-z.png": "eRQ3",
	"./luyin-z@2x.png": "Y+XA",
	"./note.png": "oE0e",
	"./noteicon.png": "ckDd",
	"./original-x-en.png": "EqTz",
	"./original-x.png": "UKgg",
	"./original-z-en.png": "JXAS",
	"./original-z.png": "Np/y",
	"./playing-h.png": "7kLD",
	"./playing-s-h.png": "uizm",
	"./playing-s.png": "f89P",
	"./playing.png": "V56Y",
	"./progress-mic-c.png": "+VK5",
	"./progress-mic.png": "FCNb",
	"./r.png": "vcyD",
	"./radio-i.png": "SXiZ",
	"./radio-s.png": "6wYI",
	"./re-record-icon.png": "Kpju",
	"./re-record-icon@2x.png": "dM9C",
	"./recording.png": "Kf2s",
	"./section-charge-hearing.png": "TfbX",
	"./section-charge-read.png": "wUXM",
	"./section-charge-say.png": "sj0S",
	"./section-charge-writing.png": "nVCD",
	"./section-tpo-hearing.png": "RGyT",
	"./section-tpo-read.png": "O2Dw",
	"./section-tpo-say.png": "7J6D",
	"./section-tpo-writing.png": "nea0",
	"./start-recording.png": "Ofn1",
	"./sy-icon.png": "xMkz",
	"./sy-icon@2x.png": "GAwF",
	"./time-c.png": "vYz2",
	"./time-o.png": "YLFZ",
	"./topic-charge-section.png": "3pYj",
	"./topic-difference.png": "kemw",
	"./topic-official-section.png": "5sqD",
	"./tpoExam.png": "SBgP",
	"./tpoListening.png": "sRaM",
	"./tpoReading.png": "ifLg",
	"./tpoSpeaking.png": "JNYV",
	"./tpoWriting.png": "0zFC",
	"./undisclosedListening.png": "OqLW",
	"./undisclosedReading.png": "za3A",
	"./undisclosedSpeaking.png": "GlQ1",
	"./undisclosedWriting.png": "quBf",
	"./vip.png": "evvg",
	"./vip2.png": "joXC",
	"./volume-icon.png": "ss8T",
	"./warning-icon.png": "Tlf/",
	"./xiaoyisi.png": "Nojl",
	"./xiaoyisi2.png": "+t98",
	"./zidian-b.png": "egHj",
	"./zidian-b@2x.png": "Iyqw",
	"./zidian-x.png": "fz4j",
	"./zidian-x@2x.png": "6EzK",
	"./zidian-z.png": "Bitr",
	"./zidian-z@2x.png": "Wuw8",
	"./不能录音.png": "V/pQ",
	"./不能录音@2x.png": "in6v",
	"./关闭.png": "jxy1",
	"./关闭@2x.png": "x3B3",
	"./录音@2x.png": "lKs/",
	"./椭圆 1265 拷贝@2x.png": "gb1W",
	"./椭圆 1265@2x.png": "WCNV",
	"./滑块.png": "Uswh",
	"./滑块@2x.png": "qNx6",
	"./矢量智能对象.png": "B2zL",
	"./矢量智能对象@2x.png": "DW0T",
	"./组 44.png": "vYf9",
	"./组 44@2x.png": "D4LO",
	"./组 45.png": "kxEU",
	"./组 46.png": "k1Y3",
	"./耳机.png": "AVQN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y5eB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl ^\.\/.*\.png$
// module id = Y5eB
// module chunks = 96